import { InvitationToken, type InvitationTokenKind } from 'models';
import { useMutation } from 'query';
import { getInviteToken } from '../../services';

type Variables = {
  kind: InvitationTokenKind;
  subjectId: string;
};

export const useGenerateInviteTokenMutation = () =>
  useMutation<InvitationToken, Variables>({
    async mutationFn({ kind, subjectId }: Variables) {
      const resposne = await getInviteToken({
        kind,
        subject_id: subjectId,
        subject_type: 'Event',
      });

      return new InvitationToken(resposne.data);
    },
  });
